module.exports = __webpack_public_path__ + "img/sprite.17ca2629.svg";